/**
 * Day-of-Week Heatmap Chart (Highcharts)
 * Heatmap showing reservations by day of week and month
 */
import { useMemo } from 'react';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
// CRITICAL FIX: Import heatmap module correctly - it's a side-effect module that modifies Highcharts
// The module itself doesn't export a function, it modifies Highcharts when imported
import 'highcharts/modules/heatmap';

export default function DayOfWeekHeatmapChart({ data = [] }) {
  const options = useMemo(() => {
    if (!data || data.length === 0) {
      return {
        title: { text: 'Reservations by Check-in Day' },
        subtitle: { text: 'No data available for this period/channel' },
        series: [],
      };
    }

    // Get unique months and sort them
    const months = [...new Set(data.map(d => d.month))].sort();
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    // Build heatmap data: [x (day_of_week), y (month index), value]
    const heatmapData = [];
    months.forEach((month, monthIdx) => {
      for (let dow = 0; dow < 7; dow++) {
        const item = data.find(d => d.month === month && d.day_of_week === dow);
        heatmapData.push([dow, monthIdx, item ? item.reservation_count : 0]);
      }
    });

    return {
      chart: {
        type: 'heatmap',
        height: 400,
      },
      title: {
        text: 'Reservations by Check-in Day',
        style: { fontSize: '16px', fontWeight: '600' },
      },
      xAxis: {
        categories: dayNames,
        title: { text: 'Check-in Day of Week' },
      },
      yAxis: {
        categories: months,
        title: { text: 'Month' },
      },
      colorAxis: {
        min: 0,
        minColor: '#FFFFFF',
        maxColor: '#4A6FAE', // Matches --color-channel-vrbo (used as max intensity color)
      },
      legend: {
        align: 'right',
        layout: 'vertical',
        margin: 0,
      },
      tooltip: {
        backgroundColor: '#ffffff', // Fully opaque white background
        borderColor: '#e5e7eb',
        borderWidth: 1,
        style: {
          color: '#111827', // Dark text for readability
        },
        formatter: function() {
          return '<b>' + months[this.point.y] + '</b><br/>' +
            '<b>' + dayNames[this.point.x] + '</b><br/>' +
            'Reservations: <b>' + this.point.value + '</b>';
        },
      },
      series: [{
        name: 'Reservations',
        borderWidth: 1,
        data: heatmapData,
        dataLabels: {
          enabled: true,
          color: '#000000',
        },
      }],
      credits: { enabled: false },
    };
  }, [data]);

  return <HighchartsReact highcharts={Highcharts} options={options} />;
}
